import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {KlassendashboardNewFacade} from '../../state/klassendashboard/klassendashboard.facade';

@Component({
  selector: 'app-klassendashboard-individueel-table-totaal-row',
  templateUrl: './klassendashboard-individueel-table-totaal-row.component.html',
  styleUrls: ['./klassendashboard-individueel-table-totaal-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class KlassendashboardIndividueelTableTotaalRowComponent implements OnInit {

  constructor(store: KlassendashboardNewFacade) { }

  ngOnInit(): void {
  }

}
